exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".terms-condition {\n  padding: 50px 0; }\n  .terms-condition p, .terms-condition li {\n    font-family: 'helveticaneuethin';\n    margin: 0 0 25px; }\n  .terms-condition h3 {\n    margin-bottom: 10px; }\n  .terms-condition h5 {\n    font-size: 18px;\n    margin: 30px 0 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/terms-condition/terms-condition.component.scss
// module id = ../../../../../src/app/components/terms-condition/terms-condition.component.scss
// module chunks = main